import { get, post, postJson,putOne } from '../axios3'

const BASE_PATH = '/birthActivity';

//详情
export const getActivity = id => get(`${BASE_PATH}/`+id);

export const createMemberUpgradeGift = (p) => postJson(`/memberUpgradeGift/save`, p);

export const purchaseActivityDetail = (id) => get(`/memberUpgradeGift/${id}`);